import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err?.response?.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const BotService = {
  getConfig: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/accounts/${accountId}/bot-config`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  saveConfig: async (accountId, payload) => {
    try {
      ensureAuth();
      const res = await apiClient.put(`/accounts/${accountId}/bot-config`, payload);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default BotService;
